import { CONSTANTS } from '../config/constants';

const LayerUtils = {
	setView: function (layerId) {
		// Bail if we're meant to ignore the first setView
		if (this.ignoreNextSetView) {
			this.ignoreNextSetView = false;
			return false;
		}

		// the layer needs time to load and render
		setTimeout(() => {
			this.visibleMarkers = W.map.queryRenderedFeatures({ layers: [layerId] });

			// if no markers in view, zoom to the map center
			if (this.visibleMarkers.length === 0) {
				W.map.easeTo({ center: CONSTANTS.map_center, zoom: 13.5, duration: 1000 });
			}
		}, 500);
	},

	// Return a sorted array of tuples for latlng,distance, by
	// distance ASC.
	// TODO: this would sort the layer markers by distance ASC
	// and then pan to the bounds set by the line between the
	// current map center and the closest marker.
	// However, with map.addLayer, I cannot figure out how to
	// get the layer's markers if they are not rendered in view
	sortedLocs: function () {
		// Build an array of tuples of latlng, distance from center
		// i.e. [ latlng(), 1234.12 ]

		// TODO: how to get all layer markers in this context?
		const lnglat_distances = this.ALL_LAYER_MARKERS.map((marker) => {
			const lnglat = marker.getLngLat();
			// W.map.getCenter() is center of current viewport
			return [lnglat, lnglat.distanceTo(W.map.getCenter())];
		});
		// Sort the array of tuples by position 1 (distance)
		const sorted = lnglat_distances.sort((a, b) => {
			a[1] - b[1];
		});
		return sorted;
	},
};

export default LayerUtils;
